import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  // Flow input params
  flowInputParams: {
    // Product name is derived from product slug name in the URL
    productName: null,
    // Nonce value to identify users when they come back from other flows
    nonce: null,
  },

  // Card details, addresses and apply card result fetched only flow init
  card: null,

  // Shipping address to display on CardNotReceivedPage
  shippingAddress: null,

  // Activate card form
  activateCardForm: {
    cvv: null,
    pin: null,
    confirmPin: null,
    pinValidated: false,
    pageErrors: {
      enterCvv: null,
      createPin: null,
      confirmPin: null,
    },
  },
}

const activateCardSlice = createSlice({
  name: 'activateCard',
  initialState,
  reducers: {
    initActivateCard(state, action) {
      const { card, shippingAddress } = action.payload
      state.card = card
      state.shippingAddress = shippingAddress
    },
    initFlowInputParams(state, action) {
      const { productName, nonce } = action.payload || {}
      state.flowInputParams.productName = productName
      state.flowInputParams.nonce = nonce
    },
    updateCvv(state, action) {
      state.activateCardForm.cvv = action.payload
      state.activateCardForm.pageErrors.createPin = null
      state.activateCardForm.pageErrors.cvv = null
    },
    setPageError(state, action) {
      const { page, error } = action.payload
      state.activateCardForm.pageErrors[page] = error
    },
    updateCreatePin(state, action) {
      state.activateCardForm.pin = action.payload
    },
    updateConfirmPin(state, action) {
      state.activateCardForm.confirmPin = action.payload
    },
    setPinValidated(state, action) {
      state.activateCardForm.pinValidated = action.payload
    },
    setCreatePinPageError(state, action) {
      state.activateCardForm.pageErrors.createPin = action.payload
    },
    resetPageError(state) {
      state.activateCardForm.pageErrors = initialState.activateCardForm.pageErrors
    },
    resetActivateCard(state) {
      Object.assign(state, initialState)
    },
    resetActivateCardForm(state) {
      Object.assign(state.activateCardForm, initialState.activateCardForm)
    },
  },
})

// Custom selectors
export const selectCard = (state) => state.activateCard?.card
export const selectPinDetails = (state) => state.activateCard.card?.pinDetails
export const selectCardName = (state) => state.activateCard.card?.metadata?.shortProductName
export const selectShippingAddress = (state) => state.activateCard.shippingAddress
export const selectActivateCardForm = (state) => state.activateCard.activateCardForm
export const selectProductName = (state) => state.activateCard.flowInputParams.productName
export const selectNonce = (state) => state.activateCard.flowInputParams.nonce

export const {
  updateCvv,
  updateCreatePin,
  updateConfirmPin,
  resetActivateCard,
  pinNotMatched,
  initActivateCard,
  setPinValidated,
  setPageError,
  setCreatePinPageError,
  resetActivateCardForm,
  resetPageError,
  initFlowInputParams,
} = activateCardSlice.actions

export default activateCardSlice.reducer
